<template>
    <sso-home></sso-home>
</template>
<script>
    import ssoHome from 'ssoHome';
    export default {
    	
    }
</script>
<style lang="scss">
    
</style>



// WEBPACK FOOTER //
// src/views/sso/home/home.vue